<!DOCTYPE html>
<html lang="fr">
<head>
  <script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  })(window,document,'script','dataLayer','GTM-KGGHZPBM');</script>
  <meta charset="UTF-8">
  <meta http-equiv="X-UA-Compatible" content="IE=edge">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <meta name="keywords" content="assurance, mace, est, auxerre,maison"/>
  <meta name="description" content="mace maison de l'assurance du centre est à Auxerre"/>
  <title>mace maison assurance centre est auxerre</title>
    
</head>
<body>
<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KGGHZPBM"
height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
<app-rappelez-moi></app-rappelez-moi>
<router-outlet></router-outlet>
</body>
</html>